var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":!_vm.wapShow?'app':''}},[_c('div',{style:(!_vm.wapShow?'width: 1200px;margin: 0 auto':'')},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }